import { useState, useRef, useEffect } from "react";
import Button from "@shared/v2/Button";
import { PlaySolidV6, PauseSolidV6 } from "@shared/v2/Icomoon";
import { useTwilioRecordingStartSoundUrl } from "../../reducers/layoutReducer/selectors";

const PlayMessage = () => {
  const [isPlaying, setIsPlaying] = useState(false); // Track play/pause state
  const startSoundUrl = useTwilioRecordingStartSoundUrl();
  const audioRef = useRef(null);

  useEffect(() => {
    if (!startSoundUrl) return undefined;

    const audio = new Audio(startSoundUrl);
    audioRef.current = audio;

    // Handle audio ending to reset to play icon
    const handleAudioEnd = () => setIsPlaying(false);
    audio.addEventListener("ended", handleAudioEnd);

    // Clean up event listener when component unmounts
    return () => {
      audio.pause();
      audio.removeEventListener("ended", handleAudioEnd);
    };
  }, [startSoundUrl]);

  const togglePlayPause = () => {
    const audio = audioRef.current;
    if (!audio) return;

    if (isPlaying) {
      audio.pause();
    } else {
      audio.play();
    }

    setIsPlaying(!isPlaying);
  };

  return (
    <div>
      <Button size="small" schema="tertiary" onClick={togglePlayPause} disabled={!startSoundUrl}>
        {isPlaying ? <PauseSolidV6 size="s" /> : <PlaySolidV6 size="s" />}
        <span className="tw-pl-[4px]"> message</span>
      </Button>
    </div>
  );
};

export default PlayMessage;
